package com.fireavert.properties.shared.data_models.responses

import kotlinx.serialization.Serializable

@Serializable
data class GetPropertyNameAndIdMapResponse(val propertyNameAndIdMap: Map<String, Int>) {

}
